<!-- TEMPLATE -->
<template>
  <div class="dean-table-finance-bar">
    <div class="bar-container">
      <transition name="finance-bar">
        <div class="bar" v-if="showBar">
          <div
            v-for="(item, key) in barData.details"
            :key="key"
            :class="'bar-inner ' + item.color"
            :style="{ width: item.percentage + '%' }"
          >
            <div class="tooltip">
              {{ item.title }}<br />{{ item.amount | currency }}
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!--
    <div class="total-amount">
      <span class="total-amount-cell">{{ data.totalAmount | currency }}</span>
      <span class="tooltip">Totaal</span>
    </div> 
    -->
    <div class="credit-container">
      <div class="credit" :class="creditClass">
        <div class="credit-inner">
          €
        </div>
        <div class="tooltip">
          {{ barData.credit.title }}<br />{{ barData.credit.amount | currency }}
        </div>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import VueCurrencyFilter from 'vue-currency-filter';

Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
});

// COMPONENTS
import deanTooltip from './deanTooltip.vue';

@Component({
  components: {
    deanTooltip
  }
})
export default class deanTableFinanceBar extends Vue {
  // PROPS
  @Prop() data!: any;

  // DATA
  barData: object = this.data;
  showBar: boolean = false;

  // WATCH
  @Watch('data')
  onDataChange() {
    this.showBar = false;
    this.setBarData();
    var self = this;
    setTimeout(function() {
      self.showBar = true;
    }, 1);
  }

  // COMPUTED
  get creditClass() {
    if (this.data.credit != (undefined || null || 0 || '')) {
      console.log(this.data.credit);
      return 'credit-active';
    } else {
      return '';
    }
  }

  // METHODS
  setBarData() {
    var barData = {
      credit: {
        title: 'Credit',
        amount: 0
      },
      details: {
        recurring: {
          title: 'Maandelijks',
          color: 'data-1',
          percentage: 0,
          amount: this.data.recurring
        },
        usage: {
          title: 'Verbruik',
          color: 'data-2',
          percentage: 0,
          amount: this.data.usage
        },
        onetime: {
          title: 'Eenmalig',
          color: 'data-3',
          percentage: 0,
          amount: this.data.onetime
        }
      },
      //credit: this.data.credit,
      totalAmount: this.data.totalAmount,
      highestAmount: this.data.highestAmount
    };
    if (this.data.credit != (undefined || null || 0 || '')) {
      barData.credit.amount = this.data.credit;
    }
    console.log(barData);
    this.calculatePercentage(barData);
  }

  calculatePercentage(setBarData: any) {
    var highestAmount = setBarData.highestAmount;
    var details = setBarData.details;

    for (var item in details) {
      if (Object.prototype.hasOwnProperty.call(details, item)) {
        if (details[item].amount <= 0) {
          delete details[item];
        } else {
          let percentage =
            Number(details[item].amount) / (Number(highestAmount) / 100);
          if (percentage > 0 && percentage < 1) {
            details[item].percentage = 1;
          } else {
            let roundPercentage = Math.round(percentage / 1) * 1;
            if (
              roundPercentage <= 0 ||
              roundPercentage == null ||
              roundPercentage == undefined ||
              isNaN(roundPercentage)
            ) {
              delete details[item];
            } else {
              details[item].percentage = roundPercentage;
            }
          }
        }
      }
    }
    this.barData = setBarData;
  }

  mounted() {
    this.showBar = false;
    this.setBarData();
    this.showBar = true;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
@import '../scss/vars';

.dean-table-finance-bar {
  @include display-flex;
  position: relative;
  width: 300px;
  min-width: 100%;
  height: 30px;
  align-items: center;

  .credit-container {
    width: 30px;
    height: 30px;
    padding: 0px 0px 0px 10px;

    .credit {
      display: inline-flex;
      position: relative;
      justify-content: center;
      align-items: center;
      @include border-radius(100px);
      width: 30px;
      height: 30px;
      color: var(--color-dark-shade-4, $color-dark-shade-4);
      background: var(--color-light-shade-2, $color-light-shade-2);
      @include box-shadow(0px 1px 1px rgba(182, 182, 182, 0.8));
      &:hover {
        .tooltip {
          visibility: visible;
          top: 100%;
          opacity: 1;
        }
      }
      //background: linear-gradient(to right, $color-success-bg , $color-success, $color-success-bg);
      .credit-inner {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-size: $font-small;
        font-weight: 700;
        height: 20px;
        width: 20px;
        background: var(--color-light-shade-2, $color-light-shade-2);
        box-shadow: inset 0 1px 1px rgba(182, 182, 182, 0.8);
        @include border-radius(100px);
      }
    }
    .credit-active {
      color: rgb(151, 109, 1);
      background: #f0e68c;
      @include box-shadow(0px 1px 1px rgba(182, 182, 182, 0.8));
      .credit-inner {
        font-size: $font-small;
        font-weight: 900;
        background: #f0e68c;
      }
    }
  }

  .total-amount {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    @include border-radius(100px);
    left: 50%;
    height: 20px;
    padding: 0px 10px 0px 10px;
    cursor: pointer;
    z-index: 989;
    &:hover {
      .tooltip {
        visibility: visible;
        top: 100%;
        opacity: 1;
      }
    }

    .total-amount-cell {
      font-weight: 700;
      color: white;
      text-shadow: 1px 1px 3px black;
    }
  }

  .bar-container {
    display: inline-flex;
    background: var(--color-light-shade-4, $color-light-shade-4);
    //height: 30px;
    height: 25px;
    width: 100%;
    @include border-radius(100px);
    //padding: 5px;
    box-shadow: inset 0 1px 1px rgba(182, 182, 182, 0.2);

    .bar {
      display: inline-flex;
      width: 100%;

      .bar-inner {
        display: inline-flex;
        position: relative;
        //height: 20px;
        height: 100%;
        cursor: pointer;
        @include box-shadow(0px 1px 1px rgba(182, 182, 182, 0.3));

        &:first-child {
          @include border-radius(100px 0px 0px 100px);
        }
        &:last-child {
          @include border-radius(0px 100px 100px 0px);
        }
        &:only-child {
          @include border-radius(100px);
        }

        &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background-image: linear-gradient(
            -45deg,
            rgba(255, 255, 255, 0.4) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.4) 50%,
            rgba(255, 255, 255, 0.4) 75%,
            transparent 75%,
            transparent
          );
          background-size: 25px 25px;
          animation: move 2s linear infinite;
        }
        &:hover {
          .tooltip {
            visibility: visible;
            top: 100%;
            opacity: 1;
          }
        }
      }
    }
  }

  @media #{$small-only} {
    display: inline-flex;
    justify-content: right;
    align-items: right;
    min-width: 60%;
    max-width: 60%;
    .total-amount {
      height: 20px;
    }
    .credit-container {
      float: right;
      padding: 5px;
      .credit {
        max-width: 19px;
        max-height: 19px;
        .credit-inner {
          max-width: 15px;
          max-height: 15px;
        }
      }
    }
    .bar-container {
      max-height: 19px;
      .bar-inner {
        max-height: 100%;
        .bar {
          max-height: 100%;
        }
      }
    }
  }

  @media #{$medium-only} {
    width: 150px;
  }

  .tooltip {
    position: absolute;
    z-index: 998;
    overflow: visible;
    top: 100%;
    left: 50%;
    margin-left: -50px;
    visibility: hidden;
    width: 100px;
    background-color: var(--color-dark-shade-2, $color-dark-shade-2);
    color: white;
    text-align: center;
    @include border-radius(5px);
    border: 1px solid var(--color-dark-shade-2, $color-dark-shade-2);
    padding: 5px 0;
    opacity: 0;
    @include calc(top, 100% - 25%);
    @include transition(all 0.5s ease);

    &:before {
      content: ' ';
      position: absolute;
      z-index: 998;
      bottom: 100%;
      left: 50%;
      margin-left: -6px;
      border-width: 6px;
      border-style: solid;
      border-color: transparent transparent
        var(--color-dark-shade-2, $color-dark-shade-2) transparent;
    }

    &:after {
      content: ' ';
      position: absolute;
      z-index: 998;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent
        var(--color-dark-shade-2, $color-dark-shade-2) transparent;
    }
  }

  .data-1 {
    background: var(--color-graph-5, $color-graph-5);
  }
  .data-2 {
    background-color: var(--color-graph-6, $color-graph-6);
  }
  .data-3 {
    background-color: var(--color-graph-8, $color-graph-8);
  }

  // BAR ANIMATION KEYFRAME
  .finance-bar-enter-active {
    animation: barAnimation 3s;
  }

  @keyframes barAnimation {
    0% {
      width: 0px;
    }
  }
  @-moz-keyframes barAnimation {
    0% {
      width: 0px;
    }
  }
  @-webkit-keyframes barAnimation {
    0% {
      width: 0px;
    }
  }
}
</style>
